module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kitchen Staples and Recommended Products")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We’re keeping things simple. Here are some frequently used HG basics to have on hand, plus some specific products we LOVE…")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pantry")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Splenda No Calorie Sweetener (granulated)")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("No-calorie sweetener packets")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Splenda")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Whole-wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Old-fashioned oats")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Nonstick cooking spray")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Low-fat honey graham crackers")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Rice cakes")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Mini semi-sweet chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("25-calorie packets diet hot cocoa mix")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Swiss Miss Diet")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Canned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Canned crushed tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Canned diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Canned pineapple packed in juice (crushed, rings, and tidbits)")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Canned pure pumpkin")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Libby’s")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fridge")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fat-free liquid egg substitute")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Egg Beaters Original")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Light whipped butter or light buttery spread")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Brummel & Brown, Land O’ Lakes Whipped Light Butter")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Light vanilla soymilk (or another light vanilla milk product)")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("8th Continent Light")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blue Diamond Unsweetened Vanilla Almond Breeze")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The Laughing Cow Light Original Swiss cheese wedges")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Light string cheese")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Jell-O Sugar Free Pudding Snacks")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fat-free yogurt")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yoplait Light, Fiber One, Fage Total 0% Greek yogurt")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Reduced-fat Parmesan-style grated topping")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Reduced-sodium/lite soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Sugar-free pancake syrup")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Log Cabin Sugar Free, Mrs. Butterworth’s Sugar Free")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Hellmann’s/Best Foods Dijonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fat-free or nearly fat-free franks")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hebrew National 97% Fat Free Beef Franks")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hoffy Extra Lean Beef Franks")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Precooked real crumbled bacon")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oscar Mayer, Hormel")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Turkey bacon or center-cut bacon")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Pillsbury Crescent Recipe Creations Seamless Dough Sheet")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("House Foods Tofu Shirataki Noodle Substitute (stocked with the tofu)")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Broccoli cole slaw")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mann’s Sunny Shores")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh Produce")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Romaine lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Onions")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Bell peppers")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Cucumbers")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fuji apples")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Freezer")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Boneless skinless lean chicken breast cutlets Shrimp")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fish fillets")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Boca Original Meatless Burger (Vegan)")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Ground-beef-style soy crumbles")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Boca Meatless Ground Crumbles")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Morningstar Farms Meal Starters Grillers Recipe Crumbles")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Green Giant Just for One Broccoli & Cheese Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Assorted vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Unsweetened fruit")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Cool Whip Free")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Breadbox")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Does anyone HAVE an actual breadbox anymore?")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Light bread (40 to 45 calories and at least 2 grams of fiber per slice)")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sara Lee Delightful, Nature’s Own Light")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Light English muffins (high in fiber with about 100 calories each)")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Burrito-size tortillas with about 110 calories (high in fiber, low in fat)")]), _vm._v(" "), _c('div', {
    staticClass: "extract1"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("La Tortilla Factory Smart & Delicious Low Carb High Fiber")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mission Carb Balance")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tumaro’s 8")]), _vm._v("” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Low in Carbs or Healthy Flour Tortillas")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "-10pt",
      "margin-left": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flatout Light Wraps")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/23.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ded4015e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hungrygirl123_fm02.vue
// module id = 87
// module chunks = 0